<template>
  <div class="state">
    <div v-if="tableData.length > 0">
      <el-table :data="tableData" v-loading="loading" style="width: 100%">
        <el-table-column prop="name" :label="$t('nodes.name')" />
        <el-table-column align="center">
          <template #header>
            <div class="flex">
              <div class="m-r-5">
                {{ $t("nodes.state") }}
              </div>
              <el-tooltip
                effect="dark"
                :content="$t('nodes.state_title')"
                placement="top"
              >
                <el-icon>
                  <QuestionFilled />
                </el-icon>
              </el-tooltip>
            </div>
          </template>
          <template #default="scope">
            <div class="container" v-if="scope.row.state === 'online'">
              <div class="dot"></div>
              <div class="pulse"></div>
            </div>
            <div class="container" v-else>
              <div class="dot-err"></div>
              <div class="pulse-err"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="left" v-if="!store.state.isMobile">
          <template #header>
            <div class="flex">
              <div class="m-r-5">
                {{ $t("nodes.magnification") }}
              </div>
              <el-tooltip
                effect="dark"
                :content="$t('nodes.magnification_title')"
                placement="top"
              >
                <el-icon>
                  <QuestionFilled />
                </el-icon>
              </el-tooltip>
            </div>
          </template>
          <template #default="scope">
            <el-tag class="ml-2" type="info"
              >{{ scope.row.magnification }}×</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          :label="$t('nodes.label')"
          v-if="!store.state.isMobile"
        >
          <template #default="scope">
            <div v-if="scope.row.label.length > 0">
              <el-tag type="info" v-for="l in scope.row.label" :key="l">{{
                l
              }}</el-tag>
            </div>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-else style="background-color: #d6d8d9; padding: 10px">
      <div class="flex">
        {{ $t("state.no_state") }}
        <el-link type="primary" @click="jumpToOrder()" class="m-l-5">
          {{ $t("state.order") }}
        </el-link>
      </div>
    </div>
  </div>
</template>

<script>
import { ElNotification } from "element-plus";
import { serverApi } from "@/utils/api";
import { QuestionFilled } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import {receive_app} from '../../utils/lang_change'
export default {
  components: { QuestionFilled },
  setup() {
    const { t, locale } = useI18n();
    const store = useStore();
    let changelanguage = (lang) => {
      locale.value = receive_app(lang);
      sessionStorage.setItem("lang", receive_app(lang));
    };
    return { t, store, changelanguage };
  },
  data() {
    return {
      tableData: [],
      loading: true,
    };
  },
  methods: {
    getNodeState() {
      serverApi().then((res) => {
        if (res !== undefined) {
          if (res.data.code === 0) {
            let data = res.data.data;
            for (let i = 0; i < data.length; i++) {
              let labelArr = data[i].label.split(",");
              this.tableData.push({
                name: data[i].name,
                magnification: data[i].mag,
                label: labelArr,
                state: data[i].status,
              });
            }
            this.loading = false;
          } else {
            return ElNotification({
              title: this.t("prompt.Mistake"),
              message: res.data.msg,
              type: "error",
              duration: 2500,
            });
          }
        } else {
          return ElNotification({
            title: "Error",
            message: "Network error",
            type: "error",
            duration: 2500,
          });
        }
      });
    },
    jumpToOrder() {
      this.store.commit("updateActiveName", "aside.purchase_subscription");
      this.store.commit("updateActivePath", "/shop");
      this.$router.push("/shop");
    },
  },
  created() {
    this.getNodeState();
    let from = this.$route.query.from;
    let lang = this.$route.query.lang;
    if (from === "mobile") {
      //手机端app跳转,去掉头部和侧边
      this.store.commit("updateMobile", true);
      this.changelanguage(lang);
    }
  },
  watch:{
    "$i18n.locale"() {
      this.tableData = [];
      this.getNodeState();
    },
  }
};
</script>


<style>
.previewDialog.el-dialog > .el-dialog__header {
  display: none;
}

.previewDialog.el-dialog > .dj-dialog-content {
  padding: 0;
  overflow: unset;
}

.previewDialog.el-dialog > .el-dialog__body {
  padding: 0;
}
</style>

<style scoped lang="less">
.divider {
  margin: 0;
}

.order_visible_item {
  width: 260px;
  height: 37.5px;
  padding: 10px 20px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
}

.order_visible_item_img {
  width: 65px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.order_visible_item_title {
  padding: 8px 0 0;
  flex: 1;
  font-size: 14px;
  color: #000000a6;
}

.order_visible_item_but {
  height: 40px;
  padding: 5px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.node_title {
  font-size: 18px;
  color: #171717;
  padding: 12px 20px;
  background-color: #f8f9fc;
}

.state {
  height: 100%;
  width: 100%;
  max-width: 1200px;
}

.subscribe {
  border-radius: 0.2rem;
  overflow-x: visible;
  padding: 0.25rem;
  transition: opacity 0.25s ease-out;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.subscribe_button {
  display: flex;
  justify-content: space-between;
}

.subscribe_button_1 {
  background-color: #409eff;
  border: 1px solid #409eff;
  border-radius: 20px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 14px;
  margin: 4px 4px 4px 0;
  padding: 4px 16px;
  cursor: pointer;
}

.subscribe_button_2 {
  border: 1px solid transparent;
  border-radius: 20px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  margin: 4px 4px 4px 0;
  padding: 4px 16px;
  color: #409eff;
  cursor: pointer;
}

.title1 {
  font-size: 20px;
  font-weight: 600;
  color: #171717;
  margin: 0 0 4px;
}

.title2 {
  margin: 0 0 20px;
  color: #6c757d;
  font-size: 14px;
}

.title3 {
  margin: 0 0 16px;
  color: #495057;
  font-size: 14px;
}

.subscribe_information {
  padding: 16px;
}
</style>